module.exports = __webpack_public_path__ + "img/logo-playgol.f65a6ba6.png";